module.exports = __webpack_public_path__ + "img/cursoOffice.de84f3fc.png";